var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { Modal } from '@doordash/component-modal';
import Button from '@doordash/component-button';
import { InlineChildren, Icon, Inset } from '@doordash/design-language';
import { useToast } from '@doordash/component-toast';
import { trackNewCardModalCancel, addCardTracking, } from './Tracking/PaymentTracking';
import AddVgsCardForm from './Vgs/AddVgsCardForm';
import { PaymentConfigProvider } from './PaymentComponents/PaymentConfigContext';
import PaymentStrings from './PaymentStrings';
import { PaymentCardTestId } from './testId';
var AddCardModal = function (_a) {
    var teamAccountId = _a.teamAccountId, onClose = _a.onClose, onAddCardComplete = _a.onAddCardComplete, paymentConfig = _a.paymentConfig;
    var _b = __read(React.useState(false), 2), isSubmitting = _b[0], setIsSubmitting = _b[1];
    var displayToast = useToast().displayToast;
    var closeAndshowSuccessToast = function () {
        displayToast({
            icon: Icon.Types.Check,
            text: PaymentStrings.addCardSuccessToast(),
            insetFromEdge: Inset.Sizes.XxxLarge,
        });
        onClose();
    };
    var onSuccess = function () {
        closeAndshowSuccessToast();
        onAddCardComplete();
    };
    return (React.createElement(Modal, { onClose: onClose, title: PaymentStrings.addCardModalTitle(), size: Modal.Sizes.Medium },
        React.createElement(PaymentConfigProvider, { value: paymentConfig },
            React.createElement(AddVgsCardForm, { teamAccountId: teamAccountId, paymentCardTracking: addCardTracking, submitting: isSubmitting, onFinish: function () { return setIsSubmitting(false); }, onSuccess: function () { return onSuccess(); } }),
            React.createElement(InlineChildren, null,
                React.createElement(Button, { onClick: function () {
                        onClose();
                        trackNewCardModalCancel();
                    }, type: Button.Types.Tertiary, "data-testid": PaymentCardTestId.AddCardModalCancelButton }, PaymentStrings.cancelButtonText()),
                React.createElement(Button, { onClick: function () { return setIsSubmitting(true); }, state: isSubmitting ? Button.States.Loading : Button.States.Default, "data-testid": PaymentCardTestId.AddCardModalSaveButton }, PaymentStrings.saveButtonText())))));
};
export default AddCardModal;
